import React from 'react';
import * as S from './Content.styled';

function Content({ children }) {
  return <S.Content>{children}</S.Content>;
}

export default Content;
